import { ScoutingPlayersPage } from "@/pages/scouting/players/page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_pathlessLayout/scouting/players")({
    component: ScoutingPlayersPage,
});
